module.exports = __webpack_public_path__ + "img/simbolos_azul.23a56d9f.jpeg";